import { render, staticRenderFns } from "./ListSubGroup.vue?vue&type=template&id=ccb935b0"
import script from "./ListSubGroup.vue?vue&type=script&lang=js"
export * from "./ListSubGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports